import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { PlannerTimeline } from '../InteractiveMapPlanner/PlannerTimeline';
import { PlannerMapPlace, PlannerLineData } from '../../types/interfaces';
import './MapSidebar.scss';

interface MapSidebarProps {
  isVisible: boolean;
  onClose: () => void;
  itineraryItems: PlannerMapPlace[];
  connectingLines: PlannerLineData[];
  activeItemId: string | null;
  onItemClick: (item: PlannerMapPlace) => void;
  onExport: () => void;
  onSavePlan?: () => void;
  timelineScrollAreaRef: React.RefObject<HTMLDivElement>;
}

export const MapSidebar: React.FC<MapSidebarProps> = ({
  isVisible,
  onClose,
  itineraryItems,
  connectingLines,
  activeItemId,
  onItemClick,
  onExport,
  onSavePlan,
  timelineScrollAreaRef,
}) => {
  if (!isVisible) return null;

  return (
    <>
      {/* Mobile overlay background */}
      <Box 
        className="map-sidebar-overlay"
        onClick={onClose}
      />
      
      <Box className="map-sidebar">
      <Box className="map-sidebar-header">
        <Typography variant="h6" className="map-sidebar-title">
          My Plan
        </Typography>
        <IconButton 
          onClick={onClose}
          className="map-sidebar-close"
          size="small"
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </Box>
      
      <Box className="map-sidebar-content">
        <PlannerTimeline
          isVisible={true}
          itineraryItems={itineraryItems}
          connectingLines={connectingLines}
          activeItemId={activeItemId}
          onClose={onClose}
          onExport={onExport}
          onSavePlan={onSavePlan}
          onItemClick={onItemClick}
          timelineScrollAreaRef={timelineScrollAreaRef}
        />
      </Box>
    </Box>
    </>
  );
};